import React from 'react'
import './header.css';

import Logo from '../assets/nav/logo.png';
import { Link } from 'react-router-dom';

const header = () => {
    return (
        <>
            <div className="hero-nav">
                <div className="hero-img">
                    <Link to='/'><img src={Logo} alt="" className="btn-zoom"/></Link>
                </div>
                <div className="nav-links">
                    <ul>
                        <li className="btn-zoom"><a href="">About</a></li>
                        <li className="btn-zoom"><a href="">Download Now</a></li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default header
